/**
 * Decode JWT payload to get expiry (exp) in milliseconds since epoch.
 * Returns null if token is invalid or exp is missing.
 */
export function getTokenExpiryMs(token: string): number | null {
  try {
    const parts = token.trim().split('.');
    if (parts.length !== 3) return null;
    const payload = JSON.parse(
      atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))
    ) as { exp?: number };
    return payload.exp != null ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

/** Returns true if token expires within the given ms (e.g. 5 min = 300000). */
export function isTokenExpiringSoon(token: string, withinMs: number): boolean {
  const exp = getTokenExpiryMs(token);
  if (exp == null) return true; // treat invalid/unknown as "refresh now"
  return exp - Date.now() < withinMs;
}
